import { render } from "./AddWeeklyContentModal.vue?vue&type=template&id=5017191e"
import script from "./AddWeeklyContentModal.vue?vue&type=script&lang=js"
export * from "./AddWeeklyContentModal.vue?vue&type=script&lang=js"

import "./AddWeeklyContentModal.vue?vue&type=style&index=0&id=5017191e&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__